import { MOCK_COMPETITIONS } from '../builder/widgetTypes';

/**
 * Mock data per competition — until real API is connected.
 * Preview and embed use the same helper so labels stay in sync.
 */

function zoneMeta(position) {
  if (position <= 4) {
    return { zone: 'ucl', zoneLabel: 'Champions League', zoneShort: 'UCL' };
  }
  if (position === 5) {
    return { zone: 'uel', zoneLabel: 'Europa League', zoneShort: 'UEL' };
  }
  if (position <= 7) {
    return { zone: 'uecl', zoneLabel: 'Conference League', zoneShort: 'UECL' };
  }
  if (position >= 18) {
    return { zone: 'relegation', zoneLabel: 'Relegation', zoneShort: '↓' };
  }
  return { zone: null, zoneLabel: null, zoneShort: null };
}

function mockStandingRow({
  position,
  team,
  points,
  played,
  won,
  drawn,
  lost,
  gf,
  ga,
  form,
  home,
  away,
}) {
  const gd = gf - ga;
  return {
    position,
    team,
    points,
    played,
    won,
    drawn,
    lost,
    gf,
    ga,
    gd,
    form,
    ...zoneMeta(position),
    overall: { played, won, drawn, lost, gf, ga, gd, points },
    home,
    away,
  };
}

const PL_STANDINGS = [
  mockStandingRow({
    position: 1,
    team: 'Arsenal',
    points: 74,
    played: 34,
    won: 23,
    drawn: 5,
    lost: 6,
    gf: 69,
    ga: 26,
    form: 'WWWDW',
    home: { played: 17, won: 13, drawn: 2, lost: 2, gf: 38, ga: 11, gd: 27, points: 41 },
    away: { played: 17, won: 10, drawn: 3, lost: 4, gf: 31, ga: 15, gd: 16, points: 33 },
  }),
  mockStandingRow({
    position: 2,
    team: 'Liverpool',
    points: 71,
    played: 34,
    won: 22,
    drawn: 5,
    lost: 7,
    gf: 72,
    ga: 35,
    form: 'WDWWL',
    home: { played: 17, won: 12, drawn: 3, lost: 2, gf: 40, ga: 16, gd: 24, points: 39 },
    away: { played: 17, won: 10, drawn: 2, lost: 5, gf: 32, ga: 19, gd: 13, points: 32 },
  }),
  mockStandingRow({
    position: 3,
    team: 'Man City',
    points: 68,
    played: 34,
    won: 21,
    drawn: 5,
    lost: 8,
    gf: 65,
    ga: 32,
    form: 'LWWWD',
    home: { played: 17, won: 12, drawn: 2, lost: 3, gf: 36, ga: 14, gd: 22, points: 38 },
    away: { played: 17, won: 9, drawn: 3, lost: 5, gf: 29, ga: 18, gd: 11, points: 30 },
  }),
  mockStandingRow({
    position: 4,
    team: 'Chelsea',
    points: 62,
    played: 34,
    won: 18,
    drawn: 8,
    lost: 8,
    gf: 58,
    ga: 38,
    form: 'DWWDL',
    home: { played: 17, won: 10, drawn: 4, lost: 3, gf: 32, ga: 18, gd: 14, points: 34 },
    away: { played: 17, won: 8, drawn: 4, lost: 5, gf: 26, ga: 20, gd: 6, points: 28 },
  }),
  mockStandingRow({
    position: 5,
    team: 'Newcastle',
    points: 58,
    played: 34,
    won: 17,
    drawn: 7,
    lost: 10,
    gf: 55,
    ga: 42,
    form: 'WLWDW',
    home: { played: 17, won: 10, drawn: 3, lost: 4, gf: 30, ga: 20, gd: 10, points: 33 },
    away: { played: 17, won: 7, drawn: 4, lost: 6, gf: 25, ga: 22, gd: 3, points: 25 },
  }),
  mockStandingRow({
    position: 6,
    team: 'Tottenham',
    points: 56,
    played: 34,
    won: 16,
    drawn: 8,
    lost: 10,
    gf: 60,
    ga: 48,
    form: 'WDLWW',
    home: { played: 17, won: 9, drawn: 4, lost: 4, gf: 34, ga: 22, gd: 12, points: 31 },
    away: { played: 17, won: 7, drawn: 4, lost: 6, gf: 26, ga: 26, gd: 0, points: 25 },
  }),
  mockStandingRow({
    position: 7,
    team: 'Brighton',
    points: 54,
    played: 34,
    won: 15,
    drawn: 9,
    lost: 10,
    gf: 52,
    ga: 45,
    form: 'DDWLW',
    home: { played: 17, won: 9, drawn: 4, lost: 4, gf: 28, ga: 20, gd: 8, points: 31 },
    away: { played: 17, won: 6, drawn: 5, lost: 6, gf: 24, ga: 25, gd: -1, points: 23 },
  }),
  mockStandingRow({
    position: 18,
    team: 'Leicester',
    points: 28,
    played: 34,
    won: 6,
    drawn: 7,
    lost: 21,
    gf: 32,
    ga: 58,
    form: 'LLLDL',
    home: { played: 17, won: 4, drawn: 4, lost: 9, gf: 18, ga: 26, gd: -8, points: 16 },
    away: { played: 17, won: 2, drawn: 3, lost: 12, gf: 14, ga: 32, gd: -18, points: 12 },
  }),
];

const BY_ID = {
  pl: {
    label: 'Premier League',
    featuredMatch: {
      home: 'Arsenal',
      away: 'Chelsea',
      score: '2–1',
      status: 'live',
      minute: "74'",
      venue: 'Emirates Stadium',
      referee: 'A. Taylor',
      coaches: {
        home: {
          name: 'Mikel Arteta',
          nationality: 'Spain',
          age: '42',
          role: 'Head coach',
          since: '2019',
        },
        away: {
          name: 'Enzo Maresca',
          nationality: 'Italy',
          age: '44',
          role: 'Head coach',
          since: '2024',
        },
      },
      ht: { label: '1–0' },
      goals: [
        { minute: '23', player: 'Saka', team: 'home', assist: 'Ødegaard' },
        { minute: '74', player: 'Havertz', team: 'home', assist: '' },
      ],
      lineups: {
        home: { formation: '4-3-3', players: [{ number: '1', name: 'Raya' }, { number: '7', name: 'Saka' }] },
        away: { formation: '4-2-3-1', players: [{ number: '1', name: 'Sánchez' }, { number: '20', name: 'Palmer' }] },
      },
    },
    squads: {
      Arsenal: [
        {
          player: 'Bukayo Saka',
          number: '7',
          age: '23',
          position: 'M',
          nationality: 'England',
          goals: 6,
          assists: 10,
          appearances: 35,
          minutes: 2800,
          rating: '7.4',
          isCaptain: false,
          injured: false,
        },
        {
          player: 'Martin Ødegaard',
          number: '8',
          age: '26',
          position: 'M',
          nationality: 'Norway',
          goals: 3,
          assists: 9,
          appearances: 32,
          minutes: 2650,
          rating: '7.6',
          isCaptain: true,
          injured: true,
        },
        {
          player: 'David Raya',
          number: '22',
          age: '29',
          position: 'G',
          nationality: 'Spain',
          goals: 0,
          assists: 0,
          appearances: 36,
          minutes: 3240,
          rating: '7.1',
          injured: false,
        },
        {
          player: 'Gabriel Jesus',
          number: '9',
          age: '28',
          position: 'A',
          nationality: 'Brazil',
          goals: 4,
          assists: 2,
          appearances: 18,
          minutes: 1200,
          rating: '6.8',
          injured: true,
        },
      ],
      Chelsea: [
        {
          player: 'Cole Palmer',
          number: '20',
          age: '22',
          position: 'M',
          nationality: 'England',
          goals: 14,
          assists: 8,
          appearances: 34,
          minutes: 2900,
          rating: '7.8',
          isCaptain: false,
          injured: false,
        },
        {
          player: 'Enzo Fernández',
          number: '8',
          age: '24',
          position: 'M',
          nationality: 'Argentina',
          goals: 6,
          assists: 7,
          appearances: 33,
          minutes: 2750,
          rating: '7.2',
          injured: false,
        },
        {
          player: 'Reece James',
          number: '24',
          age: '25',
          position: 'D',
          nationality: 'England',
          goals: 1,
          assists: 3,
          appearances: 22,
          minutes: 1800,
          rating: '6.9',
          injured: true,
        },
      ],
      Liverpool: [
        {
          player: 'Mohamed Salah',
          number: '11',
          age: '33',
          position: 'A',
          nationality: 'Egypt',
          goals: 18,
          assists: 12,
          appearances: 36,
          minutes: 3100,
          rating: '7.9',
          injured: false,
        },
        {
          player: 'Virgil van Dijk',
          number: '4',
          age: '33',
          position: 'D',
          nationality: 'Netherlands',
          goals: 2,
          assists: 1,
          appearances: 35,
          minutes: 3150,
          rating: '7.5',
          isCaptain: true,
          injured: false,
        },
        {
          player: 'Alisson Becker',
          number: '1',
          age: '32',
          position: 'G',
          nationality: 'Brazil',
          goals: 0,
          assists: 0,
          appearances: 28,
          minutes: 2520,
          rating: '7.0',
          injured: true,
        },
      ],
    },
    scorers: [
      { rank: 1, player: 'Haaland', team: 'Man City', goals: 26, assists: 8 },
      { rank: 2, player: 'Salah', team: 'Liverpool', goals: 18, assists: 12 },
    ],
    assists: [
      { rank: 1, player: 'Salah', team: 'Liverpool', assists: 12, goals: 18 },
      { rank: 2, player: 'Palmer', team: 'Chelsea', assists: 10, goals: 14 },
    ],
    injuries: [
      { player: 'Jesus', team: 'Arsenal', position: 'F', appearances: 8 },
      { player: 'Timber', team: 'Arsenal', position: 'D', appearances: 14 },
      { player: 'Ødegaard', team: 'Arsenal', position: 'M', appearances: 16 },
      { player: 'James', team: 'Chelsea', position: 'D', appearances: 11 },
      { player: 'Colwill', team: 'Chelsea', position: 'D', appearances: 19 },
      { player: 'Alexander-Arnold', team: 'Liverpool', position: 'D', appearances: 12 },
      { player: 'Alisson', team: 'Liverpool', position: 'GK', appearances: 15 },
      { player: 'Rodri', team: 'Man City', position: 'M', appearances: 17 },
    ],
    events: [
      { type: 'goal', minute: '23', player: 'Saka', team: 'home', assist: 'Ødegaard', result: '1–0' },
      { type: 'yellowcard', minute: '41', player: 'Caicedo', team: 'away' },
      { type: 'subst', minute: '62', player: 'Trossard', team: 'home', playerOff: 'Martinelli' },
      { type: 'goal', minute: '74', player: 'Havertz', team: 'home', result: '2–1' },
    ],
    goals: [
      { minute: '23', player: 'Saka', team: 'home', assist: 'Ødegaard', type: 'goal' },
      { minute: '74', player: 'Havertz', team: 'home', assist: '', type: 'goal' },
    ],
    matches: [
      { home: 'Arsenal', away: 'Chelsea', score: '2–1', live: true, minute: "74'" },
      { home: 'Liverpool', away: 'Spurs', score: '0–0', live: true, minute: "38'" },
      { home: 'Man City', away: 'Everton', score: '3–1', finished: true },
      { home: 'Newcastle', away: 'Brighton', score: 'Sat 15:00', upcoming: true },
    ],
    liveMatches: [
      { home: 'Arsenal', away: 'Chelsea', score: '2–1', live: true, minute: "74'" },
      { home: 'Liverpool', away: 'Spurs', score: '0–0', live: true, minute: "38'" },
    ],
    fixtures: [
      { home: 'Newcastle', away: 'Brighton', score: 'Sat 15:00', upcoming: true },
      { home: 'West Ham', away: 'Fulham', score: 'Sun 14:00', upcoming: true },
    ],
    results: [
      { home: 'Man City', away: 'Everton', score: '3–1', finished: true },
      { home: 'Aston Villa', away: 'Wolves', score: '2–0', finished: true },
    ],
    discipline: [
      { rank: 1, player: 'Casemiro', team: 'Man Utd', yellowCards: 9, redCards: 1 },
      { rank: 2, player: 'Romero', team: 'Spurs', yellowCards: 8, redCards: 0 },
    ],
    appearances: [
      { rank: 1, player: 'Pickford', team: 'Everton', appearances: 34, goals: 0 },
      { rank: 2, player: 'Saka', team: 'Arsenal', appearances: 33, goals: 14 },
    ],
    minutes: [
      { rank: 1, player: 'Pickford', team: 'Everton', minutes: 3060, appearances: 34 },
      { rank: 2, player: 'Rodri', team: 'Man City', minutes: 2890, appearances: 32 },
    ],
    formRows: PL_STANDINGS.map(({ position, team, form, points, played }) => ({
      position,
      team,
      form,
      points,
      played,
    })),
    teams: PL_STANDINGS,
    teamStats: [
      { position: 1, team: 'Man City', gf: 45, ga: 18, gd: 27, played: 18 },
      { position: 2, team: 'Arsenal', gf: 42, ga: 20, gd: 22, played: 18 },
    ],
    teamProfile: PL_STANDINGS[0],
    playerProfile: {
      player: 'Haaland',
      team: 'Man City',
      goals: 26,
      assists: 8,
      appearances: 32,
      position: 'F',
    },
    table: PL_STANDINGS,
  },
  ucl: {
    label: 'Champions League',
    featuredMatch: { home: 'Real Madrid', away: 'Bayern', score: '1–1' },
    matches: [
      { home: 'Real Madrid', away: 'Bayern', score: '1–1', live: true },
      { home: 'Barcelona', away: 'PSG', score: '2–0', live: true },
      { home: 'Inter', away: 'Dortmund', score: '0–0', live: false },
    ],
    table: [
      ['1', 'Real Madrid', '15'],
      ['2', 'Bayern', '13'],
      ['3', 'Barcelona', '12'],
      ['4', 'PSG', '11'],
    ],
  },
  'world-cup': {
    label: 'FIFA World Cup',
    featuredMatch: { home: 'Brazil', away: 'France', score: '2–1' },
    matches: [
      { home: 'Brazil', away: 'France', score: '2–1', live: true },
      { home: 'Argentina', away: 'Germany', score: '1–1', live: true },
      { home: 'Spain', away: 'England', score: '0–0', live: false },
    ],
    groups: [
      {
        id: 'A',
        label: 'Group A',
        table: [
          ['1', 'France', '9'],
          ['2', 'Mexico', '6'],
          ['3', 'South Africa', '3'],
          ['4', 'South Korea', '0'],
        ],
      },
      {
        id: 'B',
        label: 'Group B',
        table: [
          ['1', 'Brazil', '7'],
          ['2', 'Switzerland', '5'],
          ['3', 'Serbia', '3'],
          ['4', 'Cameroon', '1'],
        ],
      },
    ],
    table: [
      ['1', 'France', '9'],
      ['2', 'Brazil', '7'],
    ],
  },
  laliga: {
    label: 'La Liga',
    featuredMatch: { home: 'Barcelona', away: 'Real Madrid', score: '3–2' },
    matches: [
      { home: 'Barcelona', away: 'Real Madrid', score: '3–2', live: true },
      { home: 'Atlético', away: 'Sevilla', score: '1–1', live: true },
      { home: 'Villarreal', away: 'Valencia', score: '2–0', live: false },
    ],
    table: [
      ['1', 'Barcelona', '40'],
      ['2', 'Real Madrid', '38'],
      ['3', 'Atlético', '35'],
      ['4', 'Girona', '32'],
    ],
  },
};

const FALLBACK = BY_ID.pl;

export function getCompetitionLabel(competitionId) {
  return (
    MOCK_COMPETITIONS.find((c) => c.id === competitionId)?.label ??
    BY_ID[competitionId]?.label ??
    FALLBACK.label
  );
}

/** @returns {{ label: string, featuredMatch: object, matches: array, table: array }} */
export function getMockCompetitionData(competitionId) {
  return BY_ID[competitionId] ?? FALLBACK;
}
